let _warned = false;

const template = document.createElement("template");

template.innerHTML = `
<style>
  :host {
    display: block;
    width: 100%;
    max-width: var(--_max-width, 1024px);
    margin-left: auto;
    margin-right: auto;
    padding: var(--_padding, var(--ctl-space-4, 16px));
    box-sizing: border-box;
  }

  /* size */
  :host([size="sm"])   { --_max-width: 640px; }
  :host([size="md"])   { --_max-width: 768px; }
  :host([size="lg"])   { --_max-width: 1024px; }
  :host([size="xl"])   { --_max-width: 1280px; }
  :host([size="full"]) { --_max-width: 100%; }

  /* padding */
  :host([padding="none"]) { --_padding: 0; }
  :host([padding="sm"])   { --_padding: var(--ctl-space-3, 12px); }
  :host([padding="md"])   { --_padding: var(--ctl-space-4, 16px); }
  :host([padding="lg"])   { --_padding: var(--ctl-space-5, 24px); }
</style>

<slot></slot>
`;

class CtlContainer extends HTMLElement {
  static get observedAttributes() {
    return ['size', 'padding'];
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open' }).appendChild(template.content.cloneNode(true));
  }

  connectedCallback() {
    if (!this.hasAttribute('size')) this.setAttribute('size', 'lg');
    if (!this.hasAttribute('padding')) this.setAttribute('padding', 'md');

    if (!_warned) {
      _warned = true;
      console.warn(
        '[ctl-container] is deprecated. Use the CSS utility class .ctl-container instead.\n' +
        '  Migration: <ctl-container size="md" padding="lg">  →  <div class="ctl-container ctl-size-md ctl-padding-lg">\n' +
        '  See: documentation for the .ctl-container utility class.'
      );
    }
  }

  attributeChangedCallback() {
    // no-op: CSS does the work
  }

  get size() { return this.getAttribute('size') || 'lg'; }
  set size(v) { this.setAttribute('size', String(v || 'lg')); }

  get padding() { return this.getAttribute('padding') || 'md'; }
  set padding(v) { this.setAttribute('padding', String(v || 'md')); }
}

customElements.define("ctl-container", CtlContainer);

export { CtlContainer };
